import { Skeleton } from '@/components/ui/skeleton';

const BADGE_SKELETONS = [
  { key: 'b0', width: 'w-16' },
  { key: 'b1', width: 'w-24' },
  { key: 'b2', width: 'w-20' },
  { key: 'b3', width: 'w-18' },
  { key: 'b4', width: 'w-16' },
  { key: 'b5', width: 'w-20' },
  { key: 'b6', width: 'w-22' },
  { key: 'b7', width: 'w-18' },
];

export function HomeHeroSkeleton() {
  return (
    <section className="relative overflow-hidden pt-8 pb-6 md:pt-12 md:pb-8">
      {/* Background gradient — same as HomeHero */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-blue-600/5 to-transparent dark:from-blue-950/20" />

      {/* Floating orbs — same as HomeHero */}
      <div className="pointer-events-none absolute -top-20 -end-20 h-72 w-72 rounded-full bg-blue-500/10 blur-3xl dark:bg-blue-400/8" />
      <div className="pointer-events-none absolute top-40 -start-16 h-56 w-56 rounded-full bg-purple-500/8 blur-3xl dark:bg-purple-400/6" />
      <div className="pointer-events-none absolute -bottom-8 end-1/3 h-48 w-48 rounded-full bg-emerald-500/8 blur-3xl dark:bg-emerald-400/6" />

      <div className="container relative mx-auto flex flex-col items-center px-4 text-center">
        {/* Brand + Headline */}
        <div className="mb-3 flex items-center justify-center gap-3">
          <Skeleton className="h-12 w-12 shrink-0 rounded-xl" />
          <Skeleton className="h-10 w-48 rounded-lg sm:w-56" />
        </div>

        {/* Headline */}
        <Skeleton className="mb-2 h-7 w-64 rounded-lg sm:h-8 sm:w-80 md:w-96" />

        {/* Description paragraph */}
        <div className="mb-4 flex max-w-2xl flex-col items-center gap-1.5">
          <Skeleton className="h-4 w-full max-w-md rounded sm:max-w-lg" />
          <Skeleton className="h-4 w-3/4 max-w-sm rounded sm:max-w-md" />
        </div>

        {/* Search bar */}
        <Skeleton className="h-14 w-full max-w-2xl rounded-2xl" />

        {/* Category badges */}
        <div className="mt-6 flex w-full max-w-2xl flex-nowrap gap-2 overflow-hidden pb-2 sm:flex-wrap sm:justify-center">
          {BADGE_SKELETONS.map(({ key, width }) => (
            <Skeleton key={key} className={`h-6 ${width} shrink-0 rounded-full`} />
          ))}
        </div>

        {/* Trust bar */}
        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          <Skeleton className="h-4 w-24 rounded" />
          <Skeleton className="h-4 w-36 rounded" />
          <Skeleton className="h-4 w-40 rounded" />
          <Skeleton className="h-4 w-28 rounded" />
        </div>
      </div>
    </section>
  );
}
